import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {Subscription} from "rxjs";


const options = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    })
};


@Injectable()
export class ConfigService {
    private key;
    private apiUrl = "https://backoffice.bak2doctor.com/api/";

    private currentStep = 1;
    public config={};

    constructor(private http: HttpClient) {

    }

    public getConfig(apiKey: string): Observable<any> {
        if (apiKey !== null) {
            this.key = apiKey;
            return this.http.get(this.apiUrl + "config?apikey=" + apiKey, options);
        }
    }

    public setCurrentStep(step) {
        this.currentStep = step;
    }

    public getCurrentStep() {
        return this.currentStep;
    }

    public getApiUrl() {
        return this.apiUrl;
    }

    public getKey() {
        return this.key;
    }
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts